<app-risk-excel-upload (imported)="onExcelImported()"></app-risk-excel-upload>

<p-tabView *ngIf="hasImportedData" styleClass="tabview-custom">
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="fa-solid fa-user"></i>
            <span class="ml-2">Flujos del cliente</span>
        </ng-template>
        <app-bank-flows-holder></app-bank-flows-holder>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="fa-solid fa-file-invoice-dollar"></i>
            <span class="ml-2">{{ jointObligorsTabLabel }}</span>
        </ng-template>
        <app-joint-holder-flows></app-joint-holder-flows>
    </p-tabPanel>
    <!-- EEFF Anual y Ratios anuales sólo aplican a Persona Moral (showFinancials). -->
    <p-tabPanel *ngIf="showFinancials">
        <ng-template pTemplate="header">
            <i class="fa-solid fa-calculator"></i>
            <span class="ml-2">EEFF Anual</span>
        </ng-template>
        <app-ratios></app-ratios>
    </p-tabPanel>
    <p-tabPanel *ngIf="showFinancials">
        <ng-template pTemplate="header">
            <i class="fa-solid fa-calculator"></i>
            <span class="ml-2">Ratios anuales</span>
        </ng-template>
        <app-financial-ratios></app-financial-ratios>
    </p-tabPanel>
    <p-tabPanel>
        <ng-template pTemplate="header">
            <i class="fa-solid fa-calculator"></i>
            <span class="ml-2">Calculadora</span>
        </ng-template>
        <app-lease-calculator></app-lease-calculator>
    </p-tabPanel>
</p-tabView>
